import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  getPusher,
  disconnectPusher,
  subscribeToChannel,
} from "../utils/pusher";
import { notificationReceived } from "../redux/liveNotificationsSlice";
import notificationSound from "../assets/new-notification.mp3";

const playSound = () => {
  new Audio(notificationSound).play().catch(() => {});
};

const useAdminPusher = () => {
  const dispatch = useDispatch();
  const adminId = useSelector((state) => state.auth.userData?.user?.id);

  useEffect(() => {
    if (!adminId) return;

    const pusher = getPusher();

    subscribeToChannel("private-admin");
    subscribeToChannel(`private-admin.${adminId}`);
    const notificationsChannel = subscribeToChannel(
      "private-admin.notifications",
    );
    const ordersChannel = subscribeToChannel("private-admin.orders");
    const chatsChannel = subscribeToChannel("private-admin.chats");

    const handleNotificationSent = (data) => {
      console.log("[Pusher] notification.sent received:", data);
      const title =
        data?.title?.ar || data?.title?.en || data?.title || "إشعار جديد";
      toast.info(title);
      playSound();
      dispatch(
        notificationReceived({
          id: `notification-${data?.id || Date.now()}`,
          type: "notification",
          title,
          message: data?.body?.ar || data?.body?.en || data?.body || "",
          date: new Date().toISOString(),
          link: "/notifications",
        }),
      );
    };

    const handleOrderCreated = (data) => {
      console.log("[Pusher] order.created received:", data);
      const title = `طلب جديد #${data?.id || ""}`;
      toast.info(title);
      playSound();
      dispatch(
        notificationReceived({
          id: `order-${data?.id || Date.now()}`,
          type: "order",
          title,
          message: "",
          date: new Date().toISOString(),
          link: data?.id ? `/product-orders/${data.id}` : "/product-orders",
        }),
      );
    };

    const handleChatMessageSent = (data) => {
      console.log("[Pusher] chat.message.sent received:", data);
      const title = data?.message || "رسالة جديدة في الدعم";
      toast.info(title);
      playSound();
      dispatch(
        notificationReceived({
          id: `chat-${data?.id || Date.now()}`,
          type: "chat",
          title,
          message: "",
          date: new Date().toISOString(),
          link: "/support",
        }),
      );
    };

    notificationsChannel.bind("notification.sent", handleNotificationSent);
    ordersChannel.bind("order.created", handleOrderCreated);
    chatsChannel.bind("chat.message.sent", handleChatMessageSent);

    return () => {
      notificationsChannel.unbind("notification.sent", handleNotificationSent);
      ordersChannel.unbind("order.created", handleOrderCreated);
      chatsChannel.unbind("chat.message.sent", handleChatMessageSent);
      pusher.unsubscribe("private-admin");
      pusher.unsubscribe(`private-admin.${adminId}`);
      pusher.unsubscribe("private-admin.notifications");
      pusher.unsubscribe("private-admin.orders");
      pusher.unsubscribe("private-admin.chats");
      disconnectPusher();
    };
  }, [adminId, dispatch]);
};

export default useAdminPusher;
